import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 17l5-5-5-5v10z"
}), 'ArrowRightTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowRightTwoTone.js
// module id = 2122
// module chunks = 2